import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "property-item rounded overflow-hidden" }
const _hoisted_2 = { class: "position-relative overflow-hidden" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "bg-primary rounded text-white position-absolute start-0 top-0 m-4 py-1 px-3" }
const _hoisted_5 = { class: "bg-white rounded-top text-primary position-absolute start-0 bottom-0 mx-4 pt-1 px-3" }
const _hoisted_6 = { class: "p-4 pb-0" }
const _hoisted_7 = { class: "text-primary mb-3" }
const _hoisted_8 = { class: "d-flex border-top" }
const _hoisted_9 = { class: "flex-fill text-center border-end py-2" }
const _hoisted_10 = { class: "flex-fill text-center border-end py-2" }
const _hoisted_11 = { class: "flex-fill text-center py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: `/property-details`,
        onClick: _ctx.storePropertyId
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "img-fluid",
            src: _ctx.property.image,
            alt: _ctx.property.title
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.property.status), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.property.type), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.property.price), 1),
      _createVNode(_component_router_link, {
        class: "d-block h5 mb-2",
        to: `/property-details`,
        onClick: _ctx.storePropertyId
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.property.title), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-map-marker-alt text-primary me-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.property.location), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("small", _hoisted_9, [
        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa fa-ruler-combined text-primary me-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.property.sqft) + " Sqft ", 1)
      ]),
      _createElementVNode("small", _hoisted_10, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-bed text-primary me-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.property.beds) + " Bed ", 1)
      ]),
      _createElementVNode("small", _hoisted_11, [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-bath text-primary me-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.property.baths) + " Bath ", 1)
      ])
    ])
  ]))
}